import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ProductImgsComponent} from './product-imgs.component';
import {ImagePickerModule} from '../image-picker/image-picker.module';
import {SharedModule} from '@vendure/admin-ui/core';

@NgModule({
  imports: [SharedModule, CommonModule, ImagePickerModule, FormsModule],
  declarations: [ProductImgsComponent],
  exports: [ProductImgsComponent],
})
export class ProductImgsModule {}
